module.exports = __webpack_public_path__ + "img/bg.9917c086.jpg";